import { HttpClient } from '../HttpClient';
/**
 * * Post Company Locations
 */
export const PostCompanyLocations = async (companyId, locationParams) => {
  try {
    const { data } = await HttpClient.post(
      `api/companies/${companyId}/locations/searchCriteria`,
      { ...locationParams }
    );
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
